import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cscontinue(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
return(
      <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free PHP Continue Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php Continue tutorial for beginners.When a Php Continue is encountered inside any loop, control automatically passes to the first statement after the loop" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,php continue break,php continue loop,php continue vs break,php for loop continue,php continue on next line,php continue 2,php foreach continue,Php Continue for loop,end for loop Php,Php exit for loop,exit while loop Php,Php foreach continue" />
 <link rel="canonical" href="https://www.codeexampler.com/php-continue" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Php Continue</h1>
    <div className="first">
        <a href="/php-break">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-goto">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

<p className="mt-4 para">A Php continue usually associated with an if
</p>



<h2 className="headings">Syntax for continue in Php:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-3">&#123;</span>
              {"\n"}
            <span className="qwerty-2">Continue</span>
            <span className="qwerty-4">;</span>
              {"\n"}
              <span className="qwerty-3">&#125;</span>
              {"\n"}
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">How to use Continue in Php:</h2>





<h2 className="headings">Q-Write a program loop starts from 2 to 14 and continues on six examples in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-4">?</span>
            <span className="qwerty-6"> php</span>
            {"\n"}
            <span className="qwerty-7">For </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-7">$</span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">2</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-7">$</span>
            <span className="qwerty-3">a </span>
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-7">14</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-7">$</span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-4">++</span>
            <span className="qwerty-3">)</span>
              {"\n"}
              <span className="qwerty-3">&#123;</span>
            {"\n"}
              <span className="qwerty">if </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-7">$</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-3"> == </span>
            <span className="qwerty-4">6</span>
            <span className="qwerty-3">)</span>
              {"\n"}
              <span className="qwerty-2">Continue</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-5">echo </span>
              <span className="qwerty-7">$</span>
                <span className="qwerty-4">a</span>
              <span className="qwerty-2">,</span>
              <span className="qwerty-3">"</span>
              <span className="qwerty-2">&#60;</span>
            <span className="qwerty-6">br/</span>
            <span className="qwerty-2">&#62;</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-3">&#125;</span>
            {"\n"}
              <span className="qwerty-4">?</span>
              <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-4">2 </span>
              {"\n"}
              <span className="qwerty-4">3 </span>
              {"\n"}
              <span className="qwerty-4">5 </span>
              {"\n"}
              <span className="qwerty-4">6 </span>
              {"\n"}
              <span className="qwerty-4">7 </span>
              {"\n"}
              <span className="qwerty-4">8 </span>
              {"\n"}
              <span className="qwerty-4">9 </span>
              {"\n"}
              <span className="qwerty-4">10 </span>
              {"\n"}
              <span className="qwerty-4">11 </span>
              {"\n"}
              <span className="qwerty-4">12 </span>
              {"\n"}
              <span className="qwerty-4">13 </span>
              {"\n"}
              <span className="qwerty-4">14 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Write a program loop starts from 1 to 10 and continue on Fourth No in Continue?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-4">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty-7">For </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-7">$</span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-7">$</span>
            <span className="qwerty-3">a </span>
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-6">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-7">$</span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-4">++</span>
            <span className="qwerty-2">)</span>
              {"\n"}
              <span className="qwerty-3">&#123;</span>
            {"\n"}
              <span className="qwerty">if </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-7">$</span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-3"> == </span>
            <span className="qwerty-6">4</span>
            <span className="qwerty-2">)</span>
              {"\n"}
              <span className="qwerty-3">&#123;</span>
            {"\n"}
              <span className="qwerty-10">echo </span>
              <span className="qwerty-7">"</span>
                <span className="qwerty-4">That is</span>
              <span className="qwerty-10"> Continue</span>
              <span className="qwerty-2">\</span>
            <span className="qwerty-6">n</span>
           
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-10">Continue</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-3">&#125;</span>
            {"\n"}
              <span className="qwerty-10">echo </span>
              <span className="qwerty-7">$</span>
                <span className="qwerty-3">a</span>
              <span className="qwerty-2">, </span>
              <span className="qwerty-3">"</span>
              <span className="qwerty-2">\</span>
            <span className="qwerty-6">n</span>
           
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-3">&#125;</span>
            {"\n"}
              <span className="qwerty-4">?</span>
              <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-4">1 </span>
              {"\n"}
              <span className="qwerty-4">2 </span>
              {"\n"}
              <span className="qwerty-4">3 </span>
              {"\n"}
              <span className="qwerty-5">That is Continue</span>
              {"\n"}
              <span className="qwerty-4">5 </span>
              {"\n"}
              <span className="qwerty-4">6 </span>
              {"\n"}
              <span className="qwerty-4">7 </span>
              {"\n"}
              <span className="qwerty-4">8 </span>
              {"\n"}
              <span className="qwerty-4">9 </span>
              {"\n"}
              <span className="qwerty-4">10 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Write a Program loop starts from 1 to 10 and continues on 4 and 8 and Print String example in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-4">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty-7">For </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-7">$</span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-7">$</span>
            <span className="qwerty-3">a </span>
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-6">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-7">$</span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-4">++</span>
            <span className="qwerty-2">)</span>
              {"\n"}
              <span className="qwerty-3">&#123;</span>
            {"\n"}
              <span className="qwerty">if </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-7">$</span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-3"> == </span>
            <span className="qwerty-6">4</span>
            <span className="qwerty-2"> || </span>
            <span className="qwerty-7">$</span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-3"> == </span>
            <span className="qwerty-6">8</span>
            <span className="qwerty-2">)</span>
              {"\n"}
              <span className="qwerty-3">&#123;</span>
            {"\n"}
              <span className="qwerty-1">echo </span>
              <span className="qwerty-7">"</span>
                <span className="qwerty-4">That is</span>
              <span className="qwerty-5"> Continue</span>
              <span className="qwerty-2"> &#60;</span>
            <span className="qwerty-6">br/</span>
            <span className="qwerty-2">&#62;</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-5">Continue</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-3">&#125;</span>
            {"\n"}
              <span className="qwerty-1">echo </span>
              <span className="qwerty-7">$</span>
                <span className="qwerty-3">a</span>
              <span className="qwerty-2">, </span>
              <span className="qwerty-3">"</span>
              <span className="qwerty-2">&#60;</span>
            <span className="qwerty-6">br/</span>
            <span className="qwerty-2">&#62;</span>
            <span className="qwerty-3">";</span>
              {"\n"}
              <span className="qwerty-3">&#125;</span>
            {"\n"}
              <span className="qwerty-4">?</span>
              <span className="qwerty-3">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>
    
      <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-4">1 </span>
              {"\n"}
              <span className="qwerty-4">2 </span>
              {"\n"}
              <span className="qwerty-4">3 </span>
              {"\n"}
              <span className="qwerty-5">That is Continue</span>
              {"\n"}
              <span className="qwerty-4">5 </span>
              {"\n"}
              <span className="qwerty-4">6 </span>
              {"\n"}
              <span className="qwerty-4">7 </span>
              {"\n"}
              <span className="qwerty-5">That is Continue </span>
              {"\n"}
              <span className="qwerty-4">9 </span>
              {"\n"}
              <span className="qwerty-4">10 </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/php-break">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-goto">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>

    </div>
)

}
export default Cscontinue;